/**
 * The down key code.
 */
export const DOWN_KEY_CODE = 40;

/**
 * The enter/return key code.
 */
export const ENTER_KEY_CODE = 13;

/**
 * The space key code.
 */
export const SPACE_KEY_CODE = 32;

/**
 * The escape key code.
 */
export const ESCAPE_KEY_CODE = 27;

/**
 * The left key code.
 */
export const LEFT_KEY_CODE = 37;

/**
 * The right key code.
 */
export const RIGHT_KEY_CODE = 39;

/**
 * The tab key code.
 */
export const TAB_KEY_CODE = 9;

/**
 * The up key code.
 */
export const UP_KEY_CODE = 38;

/**
 * The up key code.
 */
export const BACKSPACE_KEY_CODE = 8;
